import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslate } from "@/hooks/use-translate";
import { Button } from "@/components/ui/button";
import ChangeLanguage from "@/components/ui/shared/change-language";
import { CheckCircle2 } from "lucide-react";

export const Route = createFileRoute("/(onboarding)/auth/verify-success")({
  component: VerificationSuccess,
});

function VerificationSuccess() {
  const { t } = useTranslate();

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Left side: branding/illustration */}
      <div className="w-1/2 hidden md:block relative overflow-hidden border-r border-gray-100 bg-white">
        <div className="absolute top-8 left-8">
          <img src="/assets/images/logo.svg" alt="Logo" width={140} />
        </div>
        <div className="flex items-center justify-center h-screen">
          <img
            src="/assets/images/verify-success.svg"
            alt="Account Verified"
            className="w-2/3"
          />
        </div>
      </div>

      {/* Right side: Success Content */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 bg-white relative">
        <div className="absolute top-8 right-8">
          <ChangeLanguage />
        </div>

        <div className="w-full max-w-md text-center">
          {/* Success Icon */}
          <div className="mx-auto w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6 animate-in zoom-in duration-500">
            <CheckCircle2 className="w-10 h-10 text-green-600" />
          </div>

          <h1 className="text-3xl font-bold tracking-tight text-gray-900 mb-3">
            {t("Account Verified!")}
          </h1>

          <p className="text-gray-600 mb-8 leading-relaxed">
            {t(
              "Your email has been successfully verified. Your SalesBox account is now fully active and ready for you to start managing your business."
            )}
          </p>

          <div className="space-y-4">
            <Link to="/">
              <Button className="w-full transition-colors">
                {t("Contine")}
              </Button>
            </Link>

            <div className="pt-6">
              <Link
                to="/auth/login"
                className="text-sm font-medium text-gray-500 hover:text-gray-800 transition-colors"
              >
                {t("Back to login")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
